// extracted by mini-css-extract-plugin
export default {"root":"Group-module__[local]___DzLWd"};